import React from 'react';

import TestLandingPage from './containers/test-landing-page.container';

const TestingApp = () => <TestLandingPage />;

export default TestingApp;
